import { FC } from 'react'

import { useCartDialog } from '../../../../app/_providers/CartProvider.client'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'

import { StyledButton } from './styles'

export const ViewOrderButton: FC = () => {
  const {
    magnolia: {
      orders: { viewOrder },
    },
  } = useTranslation()
  const { open: openCartDialog } = useCartDialog()

  return <StyledButton onClick={openCartDialog}>{viewOrder}</StyledButton>
}
